import { CheckPermissionLayout } from 'layouts';
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { PERMISSION } from 'utils';
import { ROUTE } from './constants';

export const accessConfirmReflectionRequestRoute: RouteObject[] = [
  {
    element: <CheckPermissionLayout permission={PERMISSION.ACCESS_CONFIRM_FEEDBACK} />,
    children: [
      {
        path: ROUTE.CONFIRM_REFLECTION_REQUEST,
        children: [
          {
            index: true,
            Component: lazy(() => import('pages/ConfirmReflectionRequest'))
          }
        ]
      }
    ]
  }
];
